import * as React from 'react';

export const FaceSmileIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="face-smile">
      <path
        id="Vector"
        opacity="0.4"
        d="M12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22Z"
        fill="#72757A"
      />
      <path
        id="Vector_2"
        d="M15 11.75C14.28 11.75 13.75 11.01 13.75 10C13.75 8.99 14.28 8.25 15 8.25C15.72 8.25 16.25 8.99 16.25 10C16.25 11.01 15.72 11.75 15 11.75ZM10.25 10C10.25 8.99 9.72005 8.25 9.00005 8.25C8.28005 8.25 7.75005 8.99 7.75005 10C7.75005 11.01 8.28005 11.75 9.00005 11.75C9.72005 11.75 10.25 11.01 10.25 10ZM16.6001 15.45C16.8501 15.12 16.7901 14.65 16.4601 14.4C16.1301 14.15 15.6601 14.21 15.4101 14.54C14.5901 15.62 13.35 16.24 12.01 16.24C10.67 16.24 9.42004 15.6 8.62004 14.54C8.37004 14.21 7.90005 14.14 7.57005 14.39C7.24005 14.64 7.17005 15.11 7.42005 15.44C8.50005 16.88 10.22 17.74 12.01 17.74C13.8 17.74 15.5001 16.9 16.6101 15.44L16.6001 15.45Z"
        fill="#72757A"
      />
    </g>
  </svg>
);
